import React, { useEffect, useState } from 'react';
import { Text } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { GroupActions, Relationship } from '@leverege/molten/imagine';
import { DataSources } from '@leverege/ui-attributes';
import { formatPercent } from '../../../util/Formatting';

// TODO: stolen from recovr-serves
import { jsx as _jsx } from "react/jsx-runtime";
const VARIANTS = {
  BELOW: 'pillError|pill',
  ABOVE: 'pillSuccess|pill'
};
export default function BillStateValue(props) {
  const {
    value,
    defaultValue = '---',
    context
  } = props;
  const systemId = context.target[0].data?.systemId;
  const [sellThroughRate, setSellThroughRate] = useState();
  useEffect(() => {
    async function fetchContract() {
      let companyId, actions;
      // we are at location level
      if (context.target[0]?.data?.data?.location) {
        actions = DataSources.getActions(context.target[0]).parent().parent().get();
        const location = await GlobalState.dispatch(actions);
        companyId = location.data.company.id;
      } else {
        // we are at company level
        actions = DataSources.getActions(context.target[0]).parent().parent().get();
        companyId = context.target[0].data?.data?.company.id;
      }
      const companyContractId = context.target[0].data?.data?.companyContractId;
      const relationship = Relationship.getByPath('company.companyContracts');
      const groupActions = new GroupActions({
        relationship,
        match: {
          ...actions.match,
          params: {
            companyId
          }
        },
        ttl: 30000
      });
      const companyContractActions = groupActions.item(companyContractId).get();
      const res = await GlobalState.dispatch(companyContractActions);
      setSellThroughRate(res?.data.sellThroughRate);
    }
    fetchContract();
  }, [systemId]);
  if (!value) {
    return defaultValue;
  }
  const variant = value[0] >= sellThroughRate ? VARIANTS.ABOVE : VARIANTS.BELOW;
  return /*#__PURE__*/_jsx(Text, {
    variant: variant,
    children: formatPercent(value[0])
  });
}